// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"1607338d","453":"78c5375b","504":"4fb68915","526":"856ad5c8","576":"b26badbb","657":"a71c4fe3","801":"fe4e418b","820":"ee02b074","905":"0035b4ef"}[chunkId] + ".chunk.js";
};